import React, { useState } from 'react';
import { ButtonIcon, ConfirmationDialog } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import { editingOffsetsAtom } from '../../../atoms/review';
import { videoReferenceSelectedForAlignmentCheckAtom } from '../../../atoms/videoAlignmentRequired';
import { videoReferencePropTypes } from '../../../types/videoReference';
import { ReviewOffsetsStep } from './ReviewOffsetsStep';

export function ReviewOffsetsButton({ videoReference }) {
  const intl = useIntl();
  const [displayModal, setDisplayModal] = useState(false);
  const setEditingOffsets = useSetAtom(editingOffsetsAtom);
  const setVideoSelectedForAlignmentCheck = useSetAtom(
    videoReferenceSelectedForAlignmentCheckAtom,
  );

  const handleReviewClick = () => {
    setDisplayModal(true);
    setVideoSelectedForAlignmentCheck(videoReference);
  };

  const handleCancel = () => {
    setEditingOffsets(false);
    setDisplayModal(false);
  };

  const title = intl.formatMessage({
    defaultMessage: 'Set Offsets',
    id: '67a21',
  });

  return (
    <>
      <ButtonIcon
        icon="Edit"
        onClick={handleReviewClick}
        size="small"
        title={title}
        variant="secondary"
      />
      {displayModal && (
        <ConfirmationDialog
          cancelLabel={null}
          confirmLabel={intl.formatMessage({
            defaultMessage: 'Close',
            id: 'd3d2e',
          })}
          id="review-offsets"
          isOpen={displayModal}
          onCancel={handleCancel}
          onConfirm={handleCancel}
          title={title}
        >
          <ReviewOffsetsStep />
        </ConfirmationDialog>
      )}
    </>
  );
}

ReviewOffsetsButton.propTypes = {
  videoReference: PropTypes.shape(videoReferencePropTypes).isRequired,
};
export default ReviewOffsetsButton;
